import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import {
    NotificationSubscription,
    lazyGetChannelId,
    lazyUnsubscribe,
    lazySubscribe,
} from 'owa-notification';
import { getGuid } from 'owa-guid';

export default async function prepareNotificationAndExecuteSendRequest(
    sendRequest: (
        subscriptionId: string,
        subscription: NotificationSubscription,
        channelId: string,
        notificationHandler: (notification: NotificationPayloadBase) => void
    ) => void,
    handleNotification: (notification: NotificationPayloadBase) => void
): Promise<void> {
    const subscriptionId: string = getGuid();
    const subscription: NotificationSubscription = {
        subscriptionId: subscriptionId,
        requiresExplicitSubscribe: false,
        subscriptionParameters: null,
    };

    const notificationHandler = (notification: NotificationPayloadBase) => {
        handleNotification(notification);
        lazyUnsubscribe.importAndExecute(subscription, notificationHandler);
    };

    (await lazySubscribe.import())(subscription, notificationHandler);
    const channelId = (await lazyGetChannelId.import())();

    sendRequest(subscriptionId, subscription, channelId, notificationHandler);
}
